module.exports = __webpack_public_path__ + "img/abstract1.7446976.jpg";